import React from 'react';

import { Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import StaffAutoComplete, {
  StaffAutoCompleteValue,
} from 'components/form-fields/auto-complete-fields/StaffAutoComplete';

import AppointmentPayRateLookupTable from './components/AppointmentPayRateLookupTable/AppointmentPayRateLookupTable';
import ClassPayRateLookupTable from './components/ClassPayRateLookupTable/ClassPayRateLookupTable';
import OtherWorkPayRateLookupTable from './components/OtherWorkPayRateLookupTable/OtherWorkPayRateLookupTable';

export interface PayRateFormValues {
  staff: StaffAutoCompleteValue;
}

interface IAssignPayRatesTableProps {
  permission?: boolean;
}

const AssignPayRatesTable = ({ permission = true }: IAssignPayRatesTableProps): JSX.Element => {
  const form = useForm<PayRateFormValues>({
    initialValues: {
      staff: {
        staffId: '',
        label: '',
        value: '',
      },
    },
  });

  const handleStaffValueChange = (item: StaffAutoCompleteValue | null): void => {
    const selectedStaff = {
      staffId: item ? item.staffId : '',
      value: item ? item.value : '',
      label: item ? item.label : '',
      isCoach: item ? item.isCoach : false,
    };
    form.setFieldValue('staff', selectedStaff);
  };

  return (
    <Stack p='lg'>
      <StaffAutoComplete
        data-cy='staffAutoComplete'
        label='Staff'
        placeholder='Select a staff'
        value={form.values.staff}
        onChange={handleStaffValueChange}
        error={form.errors.staff}
        sx={{ width: 'fit-content' }}
      />
      {!!form.values.staff.staffId && (
        <Stack>
          {form.values.staff.isCoach && (
            <ClassPayRateLookupTable permission={permission} staff={form.values.staff.staffId} />
          )}
          {form.values.staff.isCoach && (
            <AppointmentPayRateLookupTable permission={permission} staff={form.values.staff.staffId} />
          )}
          <OtherWorkPayRateLookupTable permission={permission} staff={form.values.staff.staffId} />
        </Stack>
      )}
    </Stack>
  );
};

export default AssignPayRatesTable;
